import React from "react";
import "./CNC.css";
import HeroImg from "../../../Gallery/ServicesImages/CNC/unnamed.jpg"; // <-- Use your image

import Img1 from "../../../Gallery/ServicesImages/CNC/Cnc1.png";
import Img2 from "../../../Gallery/ServicesImages/CNC/Cnc2.png";
import Img3 from "../../../Gallery/ServicesImages/CNC/Cnc3.png";
import Img4 from "../../../Gallery/ServicesImages/CNC/Cnc4.png";
import Img5 from "../../../Gallery/ServicesImages/CNC/Cnc5.jpg";
import Img6 from "../../../Gallery/ServicesImages/CNC/Cnc6.jpg";


function CNC() {
  return (
    <div className="cnc_wrapper">

      {/* HERO SECTION */}
      <section className="cnc_hero_section">
        <img src={HeroImg} alt="CNC Machining" className="cnc_hero_image" />

        <div className="cnc_content">
          <h1>
            Get Custom CNC Machined <br />
            Parts with Precision, Strength <br />
            & Speed
          </h1>

          <p>Perfect for quick prototypes & short complex shapes</p>

        
        </div>
      </section>

      {/* WHAT IS CNC MACHINING SECTION */}
{/* NEW — WHAT IS CNC MACHINING (Modern Compact Design) */}
<section className="cnc_about_section">

  <div className="cnc_about_left">
    <h2 className="cnc_about_title">
      What Is CNC Machining?
    </h2>

    <p className="cnc_about_text">
      CNC (Computer Numerical Control) machining is an advanced manufacturing
      process where cutting tools are guided by computer programs to precisely
      shape metal or plastic materials. It ensures high dimensional accuracy,
      excellent surface finish, and consistent repeatability for both simple
      and highly complex parts.
    </p>

    <ul className="cnc_about_points">
      <li>✔ Extremely tight tolerances & high repeatability</li>
      <li>✔ Ideal for prototypes & production-grade components</li>
      <li>✔ Supports a wide range of metals & plastics</li>
      <li>✔ Delivers superior strength, finish & accuracy</li>
    </ul>
  </div>

  <div className="cnc_about_right">
    <div className="cnc_about_icon_circle">
      <i className="fas fa-industry"></i>
    </div>
  </div>

</section>


{/* CNC IMAGE GALLERY SECTION */}
<section className="cnc_gallery_section" id="cncGallery">
  <h2 className="cnc_gallery_title">CNC Machining Gallery</h2>

  <div className="cnc_gallery_grid">

    {/* IMAGE 1 */}
    <div className="cnc_gallery_card">
      <img src={Img1} alt="CNC Machining 1" className="cnc_gallery_img" />
    </div>

    {/* IMAGE 2 */}
    <div className="cnc_gallery_card">
      <img src={Img2} alt="CNC Machining 2" className="cnc_gallery_img" />
    </div>

    {/* IMAGE 3 */}
    <div className="cnc_gallery_card">
      <img src={Img3} alt="CNC Machining 3" className="cnc_gallery_img" />
    </div>

    {/* IMAGE 4 */}
    <div className="cnc_gallery_card">
      <img src={Img4} alt="CNC Machining 4" className="cnc_gallery_img" />
    </div>

    {/* IMAGE 5 */}
    <div className="cnc_gallery_card">
      <img src={Img5} alt="CNC Machining 5" className="cnc_gallery_img" />
    </div>

    {/* IMAGE 6 */}
    <div className="cnc_gallery_card">
      <img src={Img6} alt="CNC Machining 6" className="cnc_gallery_img" />
    </div>

  </div>
</section>

{/* CNC SERVICES SECTION */}
<section className="cnc_services_section">

  {/* TITLE */}
  <div className="cnc_services_title_wrapper">
    <h1 className="cnc_services_title">CNC Machining Services</h1>
    <div className="cnc_services_circle"></div>
  </div>

  {/* GRID WRAPPER */}
  <div className="cnc_services_grid">

    {/* SERVICE 1 */}
    <div className="cnc_service_card">
      <h2>3 AXIS CNC MILLING</h2>
      <p>
        The cutting tool moves along the x, y, and z axis while 
        the part being machined is held on the bed by a vice or grip.
      </p>
    </div>

    {/* SERVICE 2 */}
    <div className="cnc_service_card">
      <h2>5 AXIS CNC MILLING</h2>
      <p>
        The cutting tool moves along the x, y, and z axis, the tool head 
        and the machine bed rotate.
      </p>
    </div>

    {/* SERVICE 3 */}
    <div className="cnc_service_card">
      <h2>CNC TURNING</h2>
      <p>
        The material block is held on the spindle which rotates at high speed 
        and the cutting tool moves radially and lengthwise while machining.
      </p>
    </div>

    {/* SERVICE 4 */}
    <div className="cnc_service_card">
      <h2>MILLING</h2>
      <p>
        The material block is fixed to the bed while the rotating cutting 
        tool moves around the block. Suitable for most machining processes.
      </p>
    </div>

  </div>

</section>
{/* ADVANTAGES OF CNC – MODERN COMPACT DESIGN */}
<section className="cnc_adv_modern_section">

  {/* TITLE */}
  <h1 className="cnc_adv_modern_title">Advantages of CNC</h1>

  {/* SUBTEXT */}
  <p className="cnc_adv_modern_subtext">
    CNC machining ensures precision, consistency and high-quality production for all industrial applications.
  </p>

  {/* GRID */}
  <div className="cnc_adv_modern_grid">

    <div className="cnc_adv_modern_card">
      <div className="cnc_adv_modern_icon">
        <i className="fas fa-bullseye"></i>
      </div>
      <h3>High Accuracy</h3>
      <p>Achieve exact dimensions with tight tolerances and highly repeatable results.</p>
    </div>

    <div className="cnc_adv_modern_card">
      <div className="cnc_adv_modern_icon">
        <i className="fas fa-cogs"></i>
      </div>
      <h3>Customisable</h3>
      <p>Every part can be tailored precisely to the required geometry and tolerances.</p>
    </div>

    <div className="cnc_adv_modern_card">
      <div className="cnc_adv_modern_icon">
        <i className="fas fa-layer-group"></i>
      </div>
      <h3>Wide Material Range</h3>
      <p>Supports aluminum, steel, brass, plastics, composites and engineering materials.</p>
    </div>

    <div className="cnc_adv_modern_card">
      <div className="cnc_adv_modern_icon">
        <i className="fas fa-clock"></i>
      </div>
      <h3>Quick Turnaround</h3>
      <p>Rapid machining with faster lead times compared to traditional processes.</p>
    </div>

  </div>

</section>

{/* MATERIALS USED IN CNC MACHINING – NEW DESIGN */}
<section className="cnc_material_section">

  {/* TITLE */}
  <div className="cnc_material_title_wrap">
    <h1 className="cnc_material_title">Materials Used in CNC Machining</h1>
    <div className="cnc_material_circle"></div>
  </div>

  {/* MATERIAL GRID */}
  <div className="cnc_material_grid">

    {/* ABS */}
    <div className="cnc_material_card">
      <div className="cnc_material_icon"><i className="fas fa-cube"></i></div>
      <h3>ABS</h3>
      <p>
        A lightweight thermoplastic with excellent impact strength and 
        good mechanical properties.
      </p>
    </div>

    {/* ALUMINIUM */}
    <div className="cnc_material_card">
      <div className="cnc_material_icon"><i className="fas fa-industry"></i></div>
      <h3>Aluminium</h3>
      <p>
        Strong, corrosion-resistant, and ideal for high-precision mechanical 
        and engineering parts.
      </p>
    </div>

    {/* MILD STEEL */}
    <div className="cnc_material_card">
      <div className="cnc_material_icon"><i className="fas fa-cogs"></i></div>
      <h3>Mild Steel</h3>
      <p>
        Offers high strength, durability, and machinability—excellent for 
        industrial and structural components.
      </p>
    </div>

    {/* ACRYLIC */}
    <div className="cnc_material_card">
      <div className="cnc_material_icon"><i className="fas fa-layer-group"></i></div>
      <h3>Acrylic</h3>
      <p>
        Lightweight, scratch-resistant, and available in clear or opaque 
        variants for visual parts.
      </p>
    </div>

  </div>

</section>






    </div>
  );
}

export default CNC;
